import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service worker intentionally removed (install-to-home-screen is covered by
// the mobile app, and it was causing stale "Loading..." states after
// deploys). This actively unregisters any worker left over from before, for
// anyone who already had it installed.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(reg => reg.unregister())
  })
}

reportWebVitals();
